var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.666 5H10c-.92 0-1.667.746-1.667 1.667v26.666c0 .92.746 1.667 1.667 1.667h6.666c.92 0 1.667-.746 1.667-1.667V6.667c0-.92-.746-1.667-1.667-1.667M30 5h-6.666c-.92 0-1.667.746-1.667 1.667v26.666c0 .92.746 1.667 1.667 1.667H30c.92 0 1.667-.746 1.667-1.667V6.667C31.667 5.747 30.921 5 30 5"
  })));
};
export default SvgPause;